import type { LogInput } from "../types/log-input";

export function log(input: LogInput) {
  // eslint-disable-next-line no-console
  console.log("log:", input);
}
